// eslint-disable-next-line no-use-before-define
import React from 'react';
import { EnvLabelContainer } from './style';
export const EnvLabelComponent = ({ envLabel }) => {
    if (!envLabel) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(EnvLabelContainer, null,
        React.createElement("div", { className: "root-app_env-label-container" },
            React.createElement("p", { className: "root-app_env-label" }, envLabel))));
};
//# sourceMappingURL=component.js.map